import {request2} from "./request.js";


// 获取当前角色微信号列表
export function getAdminWeiXinByAdminId(id) {
    return request2({
        url: `/api7/SBCenterAdminApi/AdminWeiXin/GetAdminWeiXinByAdminId?adminId=${id}`,
        method: "get",
    });
}

// 添加微信号

export function addAdminWeiXin(data) {
    return request2({
        url: `/api7/SBCenterAdminApi/AdminWeiXin/AddAdminWeiXin`,
        method: "post",
        data: data,
    });
}

// 编辑微信号

export function updateAdminWeiXin(data) {
    return request2({
        url: `/api7/SBCenterAdminApi/AdminWeiXin/EditAdminWeiXin`,
        method: "post",
        data: data,
    });
}